import React from "react";
import { useI18n } from "../i18n/I18nContext";

const HowItWorks = () => {
  const { t } = useI18n();
  return (
    <section className="bg-white" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 section">
        <div className="max-w-2xl">
          <span className="accent-bar" />
          <p className="eyebrow mb-3">{t.how.eyebrow}</p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            {t.how.title}
          </h2>
        </div>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.how.steps.map((s) => (
            <div key={s.n} className="relative" data-testid={`how-step-${s.n}`}>
              <p className="font-mono-tech text-xs text-[#016C36] font-semibold">{s.n}</p>
              <h3 className="font-display font-semibold text-lg mt-2">{s.t}</h3>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
